/* istanbul ignore file */
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useRef } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  TextField
} from '@mui/material'
import { styled } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'
import './configureDevice.css'
import { type Option } from '../../../components/GenXDropdown'
import { connect, type ConnectedProps } from 'react-redux'
import { alarmMetaData } from '../redux/actionCreators'
import { type AlarmMetaDataState } from '../redux/alarmMetaDataSlice'
import { type RootState } from '../../../store'
import {
  hasSpecialCharAtStartOrEnd,
  isValidInputData
} from '../../../utils/validator'
import AlarmRow, {
  logicalIndicatorsHigh,
  logicalIndicatorsLow
} from './alarmRow'
import LanguageStrings from '../../../i18n/locales'

interface Alarm {
  isLimitAlarmEnabled: boolean
  alarmLimit: string
  alarmLimitStateText: string
  alarmLimitRecommendationText: string
  selectedKpiDeffID: string
  alarmLimitColorOption: {
    label: string
    value: string
    color: string
  } | null
  LimitOperator: { label: string, value: string } | null
  alarmLimitSeverityId: { label: string, value: string } | null
  alarmLimitLabelId: { label: string, value: string } | null
  alarmLimitTextColorId: {
    label: string
    value: string
    color: string
  } | null
  errorMessage: string[]
}
interface FormData {
  lower: Alarm
  higher: Alarm
}

interface AddMoreDetailsProps {
  isAlarmEnabledCompo: boolean
  alarmTextColorList?: Option[]
  severityList?: Option[]
  selectOptionList?: Option[]
  handleStdDropdownSelect?: (value: any) => void
  handleChangeTextBox: (
    id: number | string,
    field: string,
    value: string | number
  ) => void
  alarmSelect: (id: number | string, field: string, value: string) => void
  handleCancel: (id: string, isCustomKpiFlag: boolean) => void
  deviceParameters?: any
  deviceIndicators?: any
  isEdit: boolean
  getTestIdPrefix?: any
}

interface FormFieldProps {
  label?: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  multiline?: boolean
  rows?: number
  type?: string
  inptTestID?: string
  disabled?: boolean
  error?: boolean
  required?: boolean
  helperText?: string
}

const deviceAlarmErrorsStrings =
  LanguageStrings().DeviceManagementCollectionStrings.DeviceAlarmErrors

const CustomTextField = styled(TextField)({
  '& input[type=number]': {
    '-moz-appearance': 'textfield'
  },
  '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
    {
      '-webkit-appearance': 'none',
      margin: 0
    }
})
const FormField: React.FC<FormFieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  multiline,
  rows,
  type,
  inptTestID,
  disabled,
  error,
  required,
  helperText
}) => (
  <Grid item xs={12} sm={6}>
    <CustomTextField
      label={label}
      value={value}
      variant='outlined'
      fullWidth
      placeholder={placeholder}
      multiline={multiline}
      rows={rows}
      type={type || 'text'}
      InputLabelProps={{ shrink: true }}
      onChange={(e) => {
        onChange(e.target.value)
      }}
      data-testid={inptTestID ?? ''}
      autoComplete='off'
      disabled={disabled}
      required={required}
      error={error}
      helperText={error && helperText}
      size='medium'
    />
  </Grid>
)

const ConfigureDevice = (
  props: PropsFromRedux & AddMoreDetailsProps
): JSX.Element => {
  const [open, setOpen] = useState(false)
  const lowerErrorList = useRef<string[]>([])
  const higherErrorList = useRef<string[]>([])
  const [formData, setFormData] = useState<FormData>({
    lower: {
      isLimitAlarmEnabled: false,
      alarmLimit: '',
      alarmLimitStateText: '',
      alarmLimitRecommendationText: '',
      selectedKpiDeffID: props.deviceIndicators?.kpiDefinitionId
        ? props.deviceIndicators?.kpiDefinitionId
        : props.deviceIndicators?.registerAddress,
      alarmLimitColorOption: null,
      alarmLimitSeverityId: null,
      alarmLimitLabelId: null,
      alarmLimitTextColorId: null,
      LimitOperator: null,
      errorMessage: []
    },
    higher: {
      isLimitAlarmEnabled: false,
      alarmLimit: '',
      alarmLimitStateText: '',
      alarmLimitRecommendationText: '',
      selectedKpiDeffID: props.deviceIndicators?.kpiDefinitionId
        ? props.deviceIndicators?.kpiDefinitionId
        : props.deviceIndicators?.registerAddress,
      alarmLimitColorOption: null,
      alarmLimitSeverityId: null,
      alarmLimitLabelId: null,
      alarmLimitTextColorId: null,
      LimitOperator: null,
      errorMessage: []
    }
  })

  const isNullorEmpty = (input?: string | null | undefined) => {
    return (
      input === undefined || input === '' || input === ' ' || input === null
    )
  }

  const handleOpen = (): void => {
    setOpen(true)
    props.alarmMetaData()

    // Create the data object to store in localStorage
    const dataToStore = {
      selectedID: props.deviceIndicators?.kpiDefinitionId
        ? props.deviceIndicators?.kpiDefinitionId
        : props.deviceIndicators?.registerAddress,
      isLowerLimitAlarmEnabled: props.deviceIndicators.isLowerLimitAlarmEnabled,
      lowerLimitOperator: props.deviceIndicators.lowerLimitOperator,
      alarmLowerLimit: props.deviceIndicators.alarmLowerLimit,
      alarmLowerLimitStateText: props.deviceIndicators.alarmLowerLimitStateText,
      alarmLowerLimitRecommendationText:
        props.deviceIndicators.alarmLowerLimitRecommendationText,
      alarmHigherLimit: props.deviceIndicators.alarmHigherLimit,
      alarmHigherLimitStateText:
        props.deviceIndicators.alarmHigherLimitStateText,
      alarmHigherLimitRecommendationText:
        props.deviceIndicators.alarmHigherLimitRecommendationText,
      alarmLowerLimitSeverityId:
        props.deviceIndicators.alarmLowerLimitSeverityId,
      alarmLowerLimitLabelId: props.deviceIndicators.alarmLowerLimitLabelId,
      isHigherLimitAlarmEnabled:
        props.deviceIndicators.isHigherLimitAlarmEnabled,
      higherLimitOperator: props.deviceIndicators.higherLimitOperator,
      alarmHigherLimitTextColorId:
        props.deviceIndicators.alarmHigherLimitTextColorId,
      alarmLowerLimitTextColorId:
        props.deviceIndicators.alarmLowerLimitTextColorId,
      alarmHigherLimitSeverityId:
        props.deviceIndicators.alarmHigherLimitSeverityId,
      alarmHigherLimitLabelId: props.deviceIndicators.alarmHigherLimitLabelId
    }

    // Store the data object in localStorage
    localStorage.setItem('alarmData', JSON.stringify(dataToStore))
  }

  const handleClose = (): void => {
    setOpen(false)
    props.handleCancel(
      formData.lower.selectedKpiDeffID,
      props.deviceIndicators.isCustomKpi
    )
  }

  useEffect(() => {
    if (props.alarmMetaDataState?.data !== null) {
      setFormData((prev) => ({
        ...prev,
        lower: {
          ...prev.lower,
          selectedKpiDeffID: props.deviceIndicators?.kpiDefinitionId
            ? props.deviceIndicators?.kpiDefinitionId
            : props.deviceIndicators?.registerAddress,
          isLimitAlarmEnabled: props.deviceIndicators.isLowerLimitAlarmEnabled,
          alarmLimit: props.deviceIndicators.alarmLowerLimit,
          alarmLimitStateText: props.deviceIndicators.alarmLowerLimitStateText,
          LimitOperator: props.deviceIndicators.lowerLimitOperator
            ? {
                label: geAlarmLowerOperatorLabel(
                  props.deviceIndicators.lowerLimitOperator
                ),
                value: props.deviceIndicators.lowerLimitOperator ?? null
              }
            : null,
          alarmLimitTextColorId: props.deviceIndicators
            .alarmLowerLimitTextColorId
            ? {
                label: geAlarmTxtColorLabel(
                  props.deviceIndicators.alarmLowerLimitTextColorId
                ),
                value:
                  props.deviceIndicators.alarmLowerLimitTextColorId ?? null,
                color: props.deviceIndicators.alarmLowerLimitColorValue
              }
            : props.alarmMetaDataState.data.alarmTextColors?.map(
              (elm: any) => ({
                label: elm.colorName,
                value: elm.alarmTextColorId,
                color: elm.colorValue
              })
            )?.[0],
          alarmLimitSeverityId: props.deviceIndicators.alarmLowerLimitSeverityId
            ? {
                label: getSeverityLevelLabel(
                  props.deviceIndicators.alarmLowerLimitSeverityId
                ),
                value: props.deviceIndicators.alarmLowerLimitSeverityId ?? null
              }
            : null,
          alarmLimitLabelId: props.deviceIndicators.alarmLowerLimitLabelId
            ? {
                label: getLabelName(
                  props.deviceIndicators.alarmLowerLimitLabelId
                ),
                value: props.deviceIndicators.alarmLowerLimitLabelId ?? null
              }
            : null,
          alarmLimitRecommendationText:
            props.deviceIndicators.alarmLowerLimitRecommendationText
        },
        higher: {
          ...prev.higher,
          selectedKpiDeffID: props.deviceIndicators?.kpiDefinitionId
            ? props.deviceIndicators?.kpiDefinitionId
            : props.deviceIndicators?.registerAddress,
          isLimitAlarmEnabled: props.deviceIndicators.isHigherLimitAlarmEnabled,
          alarmLimit: props.deviceIndicators.alarmHigherLimit,
          alarmLimitStateText: props.deviceIndicators.alarmHigherLimitStateText,
          LimitOperator: props.deviceIndicators.higherLimitOperator
            ? {
                label: geAlarmHigherOperatorLabel(
                  props.deviceIndicators.higherLimitOperator
                ),
                value: props.deviceIndicators.higherLimitOperator ?? null
              }
            : null,
          alarmLimitTextColorId: props.deviceIndicators
            .alarmHigherLimitTextColorId
            ? {
                label: geAlarmTxtColorLabel(
                  props.deviceIndicators.alarmHigherLimitTextColorId
                ),
                value:
                  props.deviceIndicators.alarmHigherLimitTextColorId ?? null,
                color: props.deviceIndicators.alarmHigherLimitColorValue
              }
            : null,
          alarmLimitSeverityId: props.deviceIndicators
            .alarmHigherLimitSeverityId
            ? {
                label: getSeverityLevelLabel(
                  props.deviceIndicators.alarmHigherLimitSeverityId
                ),
                value: props.deviceIndicators.alarmHigherLimitSeverityId ?? null
              }
            : null,
          alarmLimitLabelId: props.deviceIndicators.alarmHigherLimitLabelId
            ? {
                label: getLabelName(
                  props.deviceIndicators.alarmHigherLimitLabelId
                ),
                value: props.deviceIndicators.alarmHigherLimitLabelId ?? null
              }
            : null,
          alarmLimitRecommendationText:
            props.deviceIndicators.alarmHigherLimitRecommendationText
        }
      }))
    }
  }, [props.alarmMetaDataState?.data, props.deviceIndicators])

  const geAlarmLowerOperatorLabel = (alarmOperator: string) => {
    const operator = logicalIndicatorsLow?.find(
      (logical: any) => logical.value === alarmOperator
    )
    return operator ? operator.label : ''
  }
  const geAlarmHigherOperatorLabel = (alarmOperator: string) => {
    const operator = logicalIndicatorsHigh?.find(
      (logical: any) => logical.value === alarmOperator
    )
    return operator ? operator.label : ''
  }
  const geAlarmTxtColorLabel = (alarmTextColorId: string) => {
    const alarmTextColors = props.alarmMetaDataState?.data.alarmTextColors
    const color = alarmTextColors?.find(
      (color: any) => color.alarmTextColorId === alarmTextColorId
    )
    return color ? color.colorName : ''
  }

  const getSeverityLevelLabel = (alarmSeverityId: string) => {
    const alarmSeverities = props.alarmMetaDataState?.data.alarmSeverities
    const severity = alarmSeverities?.find(
      (severity: any) => severity.alarmSeverityId === alarmSeverityId
    )
    return severity ? severity.severityLevel : ''
  }

  const getLabelName = (alarmLabelId: string) => {
    const alarmLabels = props.alarmMetaDataState?.data.alarmLabels
    const label = alarmLabels?.find(
      (label: any) => label.alarmLabelId === alarmLabelId
    )
    return label ? label.labelName : ''
  }

  const handleFormFieldChange = (
    index: number,
    field: string,
    value: string
  ): void => {
    if (index === 0) {
      setFormData((prev) => ({
        ...prev,
        lower: {
          ...prev.lower,
          [field]: value
        }
      }))
      if (props.handleChangeTextBox !== undefined) {
        props.handleChangeTextBox(
          formData.lower.selectedKpiDeffID,
          field.replace('Limit', 'LowerLimit').charAt(0).toLocaleLowerCase() +
            field.replace('Limit', 'LowerLimit').slice(1),
          value
        )
      }
    } else if (index === 1) {
      setFormData((prev) => ({
        ...prev,
        higher: {
          ...prev.higher,
          [field]: value
        }
      }))
      if (props.handleChangeTextBox !== undefined) {
        props.handleChangeTextBox(
          formData.higher.selectedKpiDeffID,
          field.replace('Limit', 'HigherLimit').charAt(0).toLocaleLowerCase() +
            field.replace('Limit', 'HigherLimit').slice(1),
          value
        )
      }
    }
  }

  useEffect(() => {
    validateForm()
  }, [formData])

  const handleFormDropdownChange = (
    index: number,
    field: string,
    option: Option
  ): void => {
    if (index === 0) {
      setFormData((prev) => ({
        ...prev,
        lower: {
          ...prev.lower,
          [field]: option
        }
      }))
      if (props.alarmSelect !== undefined) {
        props.alarmSelect(
          formData.lower.selectedKpiDeffID,
          field.replace('Limit', 'LowerLimit').charAt(0).toLocaleLowerCase() +
            field.replace('Limit', 'LowerLimit').slice(1),
          option.value
        )
      }
    } else if (index === 1) {
      setFormData((prev) => ({
        ...prev,
        higher: {
          ...prev.higher,
          [field]: option
        }
      }))
      if (props.alarmSelect !== undefined) {
        props.alarmSelect(
          formData.higher.selectedKpiDeffID,
          field.replace('Limit', 'HigherLimit').charAt(0).toLocaleLowerCase() +
            field.replace('Limit', 'HigherLimit').slice(1),
          option.value
        )
      }
    }
  }

  const validateForm = (): boolean => {
    let lowerErrMsg = []
    let higherErrMsg = []

    if (formData?.lower?.isLimitAlarmEnabled) {
      if (isNullorEmpty(formData?.lower?.alarmLimit) || Number.isNaN(formData?.lower?.alarmLimit)) {
        lowerErrMsg.push('Threshold Value')
      }
      if (isNullorEmpty(formData?.lower?.LimitOperator?.value)) {
        lowerErrMsg.push('Operator')
      }

      if (isNullorEmpty(formData?.lower?.alarmLimitSeverityId?.value)) {
        lowerErrMsg.push('Severity')
      }
      if (isNullorEmpty(formData?.lower?.alarmLimitLabelId?.value)) {
        lowerErrMsg.push('Label')
      }
    } else {
      if (!isNullorEmpty(formData?.lower?.alarmLimit) && !Number.isNaN(formData?.lower?.alarmLimit)) {
        if (isNullorEmpty(formData?.lower?.LimitOperator?.value)) {
          lowerErrMsg.push('Operator')
        }
      }
      if (!isNullorEmpty(formData?.lower?.LimitOperator?.value)) {
        if (isNullorEmpty(formData?.lower?.alarmLimit) || Number.isNaN(formData?.lower?.alarmLimit)) {
          lowerErrMsg.push('Threshold Value')
        }
      }
    }

    if (formData?.higher?.isLimitAlarmEnabled) {
      if (isNullorEmpty(formData?.higher?.alarmLimit) || Number.isNaN(formData?.higher?.alarmLimit)) {
        higherErrMsg.push('Threshold Value')
      }
      if (isNullorEmpty(formData?.higher?.LimitOperator?.value)) {
        higherErrMsg.push('Operator')
      }

      if (isNullorEmpty(formData?.higher?.alarmLimitSeverityId?.value)) {
        higherErrMsg.push('Severity')
      }
      if (isNullorEmpty(formData?.higher?.alarmLimitLabelId?.value)) {
        higherErrMsg.push('Label')
      }
    } else {
      if (!isNullorEmpty(formData?.higher?.alarmLimit) && !Number.isNaN(formData?.higher?.alarmLimit)) {
        if (isNullorEmpty(formData?.higher?.LimitOperator?.value)) {
          higherErrMsg.push('Operator')
        }
      }
      if (!isNullorEmpty(formData?.higher?.LimitOperator?.value)) {
        if (isNullorEmpty(formData?.higher?.alarmLimit) || Number.isNaN(formData?.higher?.alarmLimit)) {
          higherErrMsg.push('Threshold Value')
        }
      }
    }

    let lowerErrors: string[] = []
    let higherErrors: string[] = []

    if (lowerErrMsg.length > 0) {
      lowerErrors.push(
        deviceAlarmErrorsStrings.ErrorPrefix +
          lowerErrMsg.slice(0, -1).join(', ') +
          (lowerErrMsg.length > 1 ? ' and ' : '') +
          lowerErrMsg.pop()
      )
    }

    if (
      (hasSpecialCharAtStartOrEnd(formData?.lower?.alarmLimitStateText) ||
      !isValidInputData(formData?.lower?.alarmLimitStateText)) && !isNullorEmpty(formData?.lower?.alarmLimitStateText)
    ) {
      lowerErrors.push(deviceAlarmErrorsStrings.InvalidAlarmText)
    }

    if (higherErrMsg.length > 0) {
      higherErrors.push(
        deviceAlarmErrorsStrings.ErrorPrefix +
          higherErrMsg.slice(0, -1).join(', ') +
          (higherErrMsg.length > 1 ? ' and ' : '') +
          higherErrMsg.pop()
      )
    }

    if (
      (hasSpecialCharAtStartOrEnd(formData?.higher?.alarmLimitStateText) ||
      !isValidInputData(formData?.higher?.alarmLimitStateText)) && !isNullorEmpty(formData?.higher?.alarmLimitStateText)
    ) {
      higherErrors.push(deviceAlarmErrorsStrings.InvalidAlarmText)
    }

    if (!isNullorEmpty(formData?.lower?.alarmLimit) && !isNullorEmpty(formData?.lower?.LimitOperator?.value)) {
      if (
        Number(formData?.lower?.alarmLimit) === Number(formData?.higher?.alarmLimit) &&
        formData?.lower?.LimitOperator?.value ===
          formData?.higher?.LimitOperator?.value
      ) {
        lowerErrors.push(deviceAlarmErrorsStrings.InvalidControlSelections)
        higherErrors.push(deviceAlarmErrorsStrings.InvalidControlSelections)
      }
    }

    if (lowerErrors.length > 0 || higherErrors.length > 0) {
      lowerErrorList.current = lowerErrors
      higherErrorList.current = higherErrors
      return false
    }

    lowerErrorList.current = []
    higherErrorList.current = []
    return true
  }
  const handleAdd = (): void => {
    props.alarmSelect(
      formData.lower.selectedKpiDeffID,
      'alarmLowerLimitTextColorId',
      formData.lower.alarmLimitTextColorId?.value ?? ''
    )
    if (!validateForm()) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }

  return (
    <div>
      <Button
        style={{ color: props.isAlarmEnabledCompo ? '#b0b0b0' : '#64C3FF' }}
        className='configur-alarm'
        color='primary'
        onClick={handleOpen}
        disabled={props.isAlarmEnabledCompo}
        data-testid={
          props?.getTestIdPrefix
            ? `${props?.getTestIdPrefix?.()}-config-btn-${
                formData.lower.selectedKpiDeffID
              }`
            : `config-alarm-${props.deviceIndicators.registerAddress}`
        }
      >
        Configure Alarm
      </Button>
      <Dialog
        className='device-details-box'
        open={open}
        onClose={handleClose}
        maxWidth='xl'
        fullWidth={false}
        sx={{
          width: 'unset',
          minWidth: 'unset',
          maxWidth: 'unset'
        }}
      >
        <DialogTitle>
          <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'
          >
            <Typography variant='h6' style={{ color: '#ffffff' }}>
              Add More Details
            </Typography>
            <IconButton
              onClick={handleClose}
              data-testId='close-configure-panel'
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ overflow: 'auto', height: { sm: '80vh', md: '50vh', lg: 'auto' }, width: { sm: '90vw', md: '80vw', lg: 'auto', xl: 'auto' } }}>
          <Grid container rowSpacing={3}>
            <AlarmRow
              errors= {lowerErrorList.current}
              formData={formData.lower}
              index={0}
              handleFormFieldChange={handleFormFieldChange}
              handleFormDropdownChange={handleFormDropdownChange}
            />
            <Grid item xs={12} sx={{ pt: 0.5 }}>
              <Box sx={{ width: '100%' }}>
                <hr style={{ border: 0, borderTop: '1px solid #A9A9A9', margin: 0 }} />
              </Box>
            </Grid>
            <AlarmRow
              errors= {higherErrorList.current}
              formData={formData.higher}
              index={1}
              handleFormFieldChange={handleFormFieldChange}
              handleFormDropdownChange={handleFormDropdownChange}
            />
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button variant='contained' className='can-btn' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant='contained'
            data-testid='add-btn'
            className='add-btn'
            onClick={handleAdd}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

interface DispatchToProps {
  alarmMetaData: () => void
}
const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  alarmMetaData: () => dispatch(alarmMetaData())
})
interface StateToProps {
  alarmMetaDataState: AlarmMetaDataState
}
const mapStateToProps = (state: RootState): StateToProps => ({
  alarmMetaDataState: state.alarmMetaDataState
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(ConfigureDevice)
